export default __webpack_public_path__ + "static/homepage_testimonial_background-04a54377230c929c35a56f07b4c27dea.svg";